/** Accepted image types for user-uploaded branding assets (logo, letterhead). */
export const IMAGE_UPLOAD_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const;

/** The `accept` attribute value for the image file inputs. */
export const IMAGE_UPLOAD_ACCEPT = IMAGE_UPLOAD_MIME_TYPES.join(',');

export const IMAGE_UPLOAD_MAX_BYTES = 5 * 1024 * 1024;

/**
 * Validates a user-selected image before upload. Returns a pt-BR error message
 * when the file is rejected, or `null` when it is acceptable.
 */
export const validateImageFile = (file: File): string | null => {
    if (!IMAGE_UPLOAD_MIME_TYPES.includes(file.type as (typeof IMAGE_UPLOAD_MIME_TYPES)[number])) {
        return 'Formato inválido. Use JPG, PNG ou WebP.';
    }
    if (file.size > IMAGE_UPLOAD_MAX_BYTES) {
        return 'Arquivo muito grande. Máximo 5MB.';
    }
    return null;
};
